<template>
  <button :type="type" class="icon-button" v-on="$listeners">
    <component :is="icon" class="icon-button__icon" :style="{ height: height }" />
  </button>
</template>

<script>
  export default {
    name: 'IconButton',
    props: {
      icon: {
        type: Object,
        required: true,
      },
      type: {
        type: String,
        default: 'button',
      },
      height: Number,
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .icon-button {
    display: flex;
    cursor: pointer;
    outline: none;
  }

  .icon-button__icon {
    height: 11.31px;
  }
</style>
